import React from 'react';
import './grievance.css';
const GrievanceRedressal = () => {
  return (
    <div className="tk-gr-wrapper">
      {/* Premium Hero Banner Block */}
      <section className="tk-gr-hero">
        <div className="container-fluid tk-gr-fluid-container">
          <div className="tk-badge-gr">SUPPORT & REDRESSAL FRAMEWORK</div>
          <h1 className="tk-hero-main-title">
            Grievance Redressal Policy
            <span className="tk-hero-subtitle">DMT Group of Companies</span>
            <span className="tk-hero-lead-text">
              We are committed to providing transparent, efficient, ethical, and customer-centric services across all business verticals and digital platforms operated by the group.
            </span>
          </h1>
        </div>
      </section>

      {/* Main Content Framework */}
      <section className="tk-gr-body pb-5">
        <div className="container tk-gr-container">
          <div className="row">
            
            <div className="col-lg-12">
              <div className="tk-gr-card">
                
                {/* Meta Header Information */}
                <div className="tk-gr-meta-box">
                  <span className="tk-meta-label">Effective Date:</span>
                  <span className="tk-meta-value">[Insert Date]</span>
                </div>

                {/* Introduction Paragraphs */}
                <div className="tk-gr-intro">
                  <p>
                    DMT Empire India Private Limited and its group entities, collectively referred to as <strong>“DMT Group”</strong>, <strong>“Company”</strong>, <strong>“we”</strong>, <strong>“our”</strong>, or <strong>“us”</strong>, are committed to providing transparent, efficient, ethical, and customer-centric services across all business verticals and digital platforms operated by the group.
                  </p>
                  <p>
                    At DMT Group, customer satisfaction, service excellence, and fair grievance handling form the foundation of our business operations. We believe that an effective grievance redressal mechanism is essential for maintaining customer trust, ensuring regulatory compliance, and delivering high-quality service experiences.
                  </p>
                  <p>
                    This Grievance Redressal Policy establishes a structured mechanism for receiving, reviewing, resolving, and escalating customer complaints, concerns, disputes, service requests, and fraud-related issues in a timely and transparent manner.
                  </p>
                  <p className="mb-0">
                    This Policy applies to all products, services, websites, mobile applications, APIs, merchant platforms, retailer services, travel services, fintech services, and digital properties operated under DMT Group including but not limited to <strong>DMT Kendra</strong>, <strong>Coupon Fares</strong>, <strong>Finwelco</strong>, and <strong>Shardajeet Foundation</strong>.
                  </p>
                </div>

                <hr className="tk-gr-divider" />

                {/* Section 1 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">1. Objective of the Policy</h3>
                  <p>The objective of this Policy is to:</p>
                  <ul className="tk-legal-list check-bullet">
                    <li>Provide customers with an accessible and efficient grievance redressal mechanism;</li>
                    <li>Ensure fair, transparent, and timely handling of customer complaints;</li>
                    <li>Enhance customer confidence and satisfaction;</li>
                    <li>Ensure compliance with applicable laws, regulatory requirements, and industry standards;</li>
                    <li>Address service deficiencies, operational concerns, disputes, and fraud-related complaints effectively.</li>
                  </ul>
                </div>

                {/* Section 2 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">2. Principles of Grievance Handling</h3>
                  <p>DMT Group is committed to:</p>
                  <ul className="tk-legal-list shield-bullet">
                    <li>Treat all customers fairly, respectfully, and courteously;</li>
                    <li>Resolve complaints in a professional, transparent, and time-bound manner;</li>
                    <li>Maintain confidentiality and privacy of customer information;</li>
                    <li>Ensure proper monitoring and escalation of unresolved grievances;</li>
                    <li>Continuously improve customer service standards through feedback and corrective actions.</li>
                  </ul>
                </div>

                {/* Section 3 - Escalation Matrix Table */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">3. Grievance Redressal Mechanism</h3>
                  <p className="mb-3">Customers may register complaints, concerns, disputes, service issues, or transaction-related grievances through the following escalation matrix:</p>
                  
                  <div className="table-responsive tk-matrix-table-container">
                    <table className="table table-bordered tk-matrix-table">
                      <thead>
                        <tr>
                          <th>Level</th>
                          <th>Response Timeline</th>
                          <th>Designation</th>
                          <th>Contact Details</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="font-weight-bold text-dark">Level 1</td>
                          <td><span className="tk-time-badge font-weight-bold">Within 24 Hours</span></td>
                          <td className="font-weight-bold text-secondary">Customer Support Desk</td>
                          <td><a href="mailto:info@dmtgroup.in" className="tk-table-link">info@dmtgroup.in</a></td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold text-dark">Level 2</td>
                          <td><span className="tk-time-badge font-weight-bold">Within 48 Hours</span></td>
                          <td className="font-weight-bold text-secondary">Manager – Customer Service</td>
                          <td><a href="mailto:help@dmtkendra.com" className="tk-table-link">help@dmtkendra.com</a></td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold text-dark">Level 3</td>
                          <td><span className="tk-time-badge font-weight-bold">Within 72 Hours</span></td>
                          <td className="font-weight-bold text-dark">Nodal Officer</td>
                          <td><a href="mailto:nodal.officer@dmtgroup.in" className="tk-table-link font-weight-bold">nodal.officer@dmtgroup.in</a></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <p className="tk-sub-note mt-3">
                    📌 <strong>Pro Tip for Users:</strong> Customers are advised to provide complete details including transaction reference number, registered mobile number, date of transaction, screenshots, and supporting documents wherever applicable for faster resolution.
                  </p>
                </div>

                {/* Section 4 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">4. Fraud Reporting & Unauthorized Transactions</h3>
                  <p>In case of any suspected fraud, unauthorized transaction, phishing attempt, cyber incident, account compromise, or suspicious activity, customers must immediately report the matter through:</p>
                  
                  <div className="row mt-3 mb-3">
                    <div className="col-md-6 mb-3 mb-md-0">
                      <div className="tk-contact-item-card">
                        <span className="tk-card-icon">✉️</span>
                        <div className="tk-card-text">
                          <label>Email Support</label>
                          <a href="mailto:info@dmtgroup.in">info@dmtgroup.in</a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="tk-contact-item-card">
                        <span className="tk-card-icon">📞</span>
                        <div className="tk-card-text">
                          <label>Customer Helpline</label>
                          <a href="tel:01204151488">0120-4151488</a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <p>DMT Group may temporarily suspend accounts, hold transactions, request additional verification, or report the matter to banks, regulators, payment networks, or law enforcement authorities wherever required under applicable law.</p>
                  <p className="tk-sub-note-danger">
                    ⚠️ <strong>Security Advisory:</strong> Customers are advised not to share OTPs, passwords, MPINs, or confidential credentials with any person.
                  </p>
                </div>

                {/* Section 5 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">5. Customer Responsibilities</h3>
                  <p>Customers are responsible for:</p>
                  <ul className="tk-legal-list check-bullet">
                    <li>Providing accurate and complete complaint details;</li>
                    <li>Maintaining confidentiality of account credentials and transaction information;</li>
                    <li>Promptly reporting unauthorized activity or suspicious transactions;</li>
                    <li>Cooperating with investigation, verification, and compliance processes.</li>
                  </ul>
                  <p className="mb-0"><em>Failure to provide adequate information or supporting documents may delay grievance resolution.</em></p>
                </div>

                {/* Section 6 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">6. Exclusions</h3>
                  <p>DMT Group shall not be liable for grievances arising due to:</p>
                  <ul className="tk-legal-list cross-bullet">
                    <li>Incorrect information provided by customers;</li>
                    <li>Negligence in safeguarding account credentials;</li>
                    <li>Failures caused by banks, telecom providers, payment gateways, IRCTC, NPCI, or third-party systems;</li>
                    <li>Force majeure events including natural disasters, technical outages, cyber-attacks, governmental restrictions, or network failures.</li>
                  </ul>
                </div>

                {/* Section 7 */}
                <div className="tk-legal-section">
                  <h3 className="tk-section-title">7. Regulatory Compliance</h3>
                  <p className="mb-0">This Policy is framed in accordance with applicable Indian laws, regulatory guidelines, and industry best practices including provisions relating to customer service, digital transactions, data protection, and grievance handling mechanisms. DMT Group reserves the right to amend, modify, or update this Policy at any time in accordance with operational, legal, or regulatory requirements.</p>
                </div>

                {/* Section 8 */}
                <div className="tk-legal-section mb-0">
                  <h3 className="tk-section-title">8. Governing Law & Jurisdiction</h3>
                  <p className="mb-0">This Policy shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or relating to this Policy shall be subject to the exclusive jurisdiction of the competent courts located in <strong>New Delhi, India</strong>.</p>
                </div>

                {/* Corporate Sign-off */}
                <div className="tk-gr-footer-note">
                  <h5>Thank you for choosing DMT Group of Companies.</h5>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default GrievanceRedressal;